<app-pan-card [isPageContainer]="true" [header]="'Update Location Instructions'" pageContainerSize="xl">
  <div class="location-form">
    <app-pan-form-control class="flex-1">
      <app-pan-floating-label>Location to Update</app-pan-floating-label>
      <ng-select
        class="form-control"
        [items]="locationOptions | async"
        [formControl]="locationControl"
        [searchFn]="search"
        [virtualScroll]="true"
        placeholder="Select location..."
        (change)="changeLocation($event)"
      >
        <ng-template ng-label-tmp let-item="item">
          <span class="relative" [ngClass]="item.is_flagged ? 'text-red-600' : ''">
            @if (item.is_flagged) {
              <div class="absolute inset-y-0 start-0 flex items-center pointer-events-none">
                <mat-icon>flag</mat-icon>
              </div>
            }
            <span [ngClass]="item.is_flagged ? 'ps-10 p-2.5' : ''">
              {{ item.location_name }}
              <span class="text-xs">({{ item.branch_name }})</span>
            </span>
          </span>
        </ng-template>

        <ng-template ng-option-tmp let-item="item">
          <span class="relative" [ngClass]="item.is_flagged ? 'text-red-600' : ''">
            @if (item.is_flagged) {
              <div class="absolute inset-y-0 start-0 flex items-center pointer-events-none">
                <mat-icon>flag</mat-icon>
              </div>
            }
            <span [ngClass]="item.is_flagged ? 'ps-10 p-2.5' : ''">
              {{ item.location_name }}
              <span class="text-xs">({{ item.branch_name }})</span>
            </span>
          </span>
        </ng-template>
      </ng-select>
    </app-pan-form-control>

    @if (isLoading) {
      <app-pan-blank-slate>
        <app-pan-spinner></app-pan-spinner>
        <span>Loading instructions... </span>
      </app-pan-blank-slate>
    }

    @if (selectedLocationId) {
      <div class="my-6">
        <app-pan-form-control>
          <app-pan-floating-label>Location Instructions</app-pan-floating-label>
          <textarea
            panTextarea
            [disabled]="isLoading || isPending"
            [(ngModel)]="instructions"
            rows="12"
            class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
            placeholder="Write instructions for location..."
          ></textarea>
        </app-pan-form-control>
      </div>
    }

    @if (locationControl.value) {
      <app-pan-button
        color="primary"
        [disabled]="!selectedLocationId || isPending"
        type="submit"
        data-test="submit-button"
        (click)="onSubmit()"
        >Submit</app-pan-button
      >
    }

    @if (message?.length > 0) {
      <div [style.color]="isError ? 'red' : ''" class="my-4 italic">
        {{ message }}
      </div>
    }
  </div>
</app-pan-card>
